import { render, staticRenderFns } from "./ToastComponent.vue?vue&type=template&id=2bc9723f&scoped=true"
import script from "./ToastComponent.vue?vue&type=script&lang=js"
export * from "./ToastComponent.vue?vue&type=script&lang=js"
import style0 from "./ToastComponent.vue?vue&type=style&index=0&id=2bc9723f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9723f",
  null
  
)

export default component.exports